import axios from 'axios';
import get from 'lodash/get';
import * as storage from 'client/javascript/storage';
import getClosestMarket from 'client/javascript/get_closest_market';
import { performAlgoliaNearbyMarketsSearch } from 'client/javascript/geo';
import { shouldShowExperimentVariant } from 'client/javascript/experiments';
import { varsFromServer } from 'client/javascript/client_side_injection_vars';
import { logError } from 'client/javascript/util/logger';
import {
  NUMBER_OF_RESULTS,
  BUILDINGS_NEAR_ME_EXPERIMENT,
  MIN_BUILDINGS_TO_RETURN,
  nearbyBuildingsSelectors,
  nearbyBuildingsSlider
} from './constants';

const hideLoader = () => {
  document.querySelector(nearbyBuildingsSelectors.loader).style.display = 'none';
};

const setBuildings = ({ geogrouping, buildingList }) => {
  const nearByBuildingsSection = document.querySelector(nearbyBuildingsSelectors.section);
  const slider = nearByBuildingsSection.querySelector(nearbyBuildingsSelectors.slider);
  const sliderList = slider.querySelector(nearbyBuildingsSelectors.sliderList);
  const card = slider.querySelector(nearbyBuildingsSelectors.sliderCard);

  nearByBuildingsSection.querySelector(nearbyBuildingsSelectors.locationTotal).textContent =
    geogrouping.buildings.length;
  nearByBuildingsSection.querySelector(nearbyBuildingsSelectors.locationName).textContent = geogrouping.name;
  nearByBuildingsSection.querySelector(nearbyBuildingsSelectors.locationCity).textContent = geogrouping.name;

  nearByBuildingsSection.querySelector(nearbyBuildingsSelectors.locationLink).href = geogrouping.path;

  buildingList.forEach(({ name, image, path, neighborhood }) => {
    const slide = document.importNode(card, true);
    slide.querySelector(nearbyBuildingsSelectors.slideNeighbor).textContent = get(neighborhood, 'name', '');
    slide.querySelector(nearbyBuildingsSelectors.slideTitle).textContent = name;
    slide.querySelector(nearbyBuildingsSelectors.cityName).textContent = geogrouping.name;
    slide.querySelector(nearbyBuildingsSelectors.slideLink).href = path;
    slide.querySelector(nearbyBuildingsSelectors.slideImage).innerHTML = `<img ${image} alt=${name}>`;
    sliderList.appendChild(slide);
  });

  // Remove empty card
  sliderList.removeChild(sliderList.childNodes[1]);

  hideLoader();
  nearByBuildingsSection.classList.add(nearbyBuildingsSelectors.activeSection);
};

const globalReach = () => {
  document.querySelector(nearbyBuildingsSelectors.globalReach).classList.add(nearbyBuildingsSelectors.activeSection);
  hideLoader();
};

export function isNearbyBuildingsAvailable() {
  return document.querySelector(nearbyBuildingsSlider);
}

const getNearByMarket = async () => {
  try {
    const {
      results: [locations]
    } = await performAlgoliaNearbyMarketsSearch(varsFromServer.locale);
    return locations;
  } catch (error) {
    globalReach();
    logError('Nearby buildings failed with an error', error);
  }
};

const getGeoGroupings = async geoLocation => {
  const [firstMarket] = geoLocation.hits;
  try {
    const { data } = await axios.get(`${varsFromServer.locale}/nearby_buildings?marketGeoId=${firstMarket.id}`);
    return data;
  } catch (error) {
    globalReach();
    logError('Nearby buildings failed with an error', error);
  }
};

export async function populateNearbyBuildingsSection() {
  const geoLocation = await getNearByMarket();
  if (isNearbyBuildingsExperimentVariant()) {
    try {
      const { geogrouping, buildingList } = await getGeoGroupings(geoLocation);
      if (buildingList.length >= MIN_BUILDINGS_TO_RETURN) {
        setBuildings({ geogrouping, buildingList });
      } else {
        globalReach();
      }
    } catch (error) {
      logError('Nearby buildings failed with an error', error);
    }
  }
}

function isNearbyBuildingsExperimentVariant() {
  return shouldShowExperimentVariant(varsFromServer.experimentsString, BUILDINGS_NEAR_ME_EXPERIMENT);
}

export async function getLocationId() {
  const closestMarket = (await getClosestMarket(NUMBER_OF_RESULTS)) || {};
  const locationIdFromLocalStorage = storage.getLocationId();
  return locationIdFromLocalStorage || closestMarket.id;
}
